import { Box, RadioGroup, Stack, Typography, theme } from '@dtx-company/design-system/src'
import { FC, useMemo } from 'react'
import { useScreenSizeBreakpoints } from '@app/common/src/hooks/useScreenSizeBreakpoints'
import FormControlLabel from '@mui/material/FormControlLabel'
import Image from 'next/image'
import Radio from '@mui/material/Radio'

export const ImageDisplayToggle: FC<{
  onChange: (_: unknown, type: string) => void
  displayType: string
  fetching: boolean
}> = ({ onChange, displayType, fetching = false }) => {
  const { isMobile } = useScreenSizeBreakpoints()

  const RadioOptions = useMemo(() => {
    const selectedRadioButtonStyles = isMobile
      ? {}
      : {
          height: '96px',
          padding: '14px 20px 14px 20px',
          borderRadius: '5px',
          backgroundColor: 'rgb(230, 239, 233)',
          borderColor: theme.palette.tertiary.main,
          borderStyle: 'solid',
          borderWidth: '2px'
        }
    const unselectedRadioButtonStyles = isMobile
      ? {}
      : {
          height: '96px',
          padding: '14px 20px 14px 20px',
          borderRadius: '5px',
          backgroundColor: 'transparent',
          border: '1px solid rgb(218, 220, 221)'
        }
    const labelPlacement = isMobile ? 'end' : 'top'

    return (
      <Stack direction={isMobile ? 'column' : 'row'} gap={'16px'} alignItems="end">
        <FormControlLabel
          labelPlacement={labelPlacement}
          value="noImage"
          control={<Radio disabled={fetching} />}
          label={
            <Stack
              direction="column"
              alignItems="center"
              justifyContent="center"
              gap={isMobile ? undefined : '4px'}
              sx={
                displayType === 'noImage' ? selectedRadioButtonStyles : unselectedRadioButtonStyles
              }
            >
              <Image src="/static/icons/LinkOption-NoImage.svg" alt="" width={67} height={20} />
              <Typography>No image</Typography>
            </Stack>
          }
        />
        <FormControlLabel
          value="default"
          labelPlacement={labelPlacement}
          control={<Radio disabled={fetching} />}
          label={
            <Stack
              direction="column"
              alignItems="center"
              justifyContent="center"
              gap={isMobile ? undefined : '4px'}
              sx={
                displayType === 'default' ? selectedRadioButtonStyles : unselectedRadioButtonStyles
              }
            >
              <Image src="/static/icons/LinkOption-Thumbnail.svg" alt="" width={67} height={20} />
              <Typography>Icon</Typography>
            </Stack>
          }
        />
        <FormControlLabel
          value="featured"
          labelPlacement={labelPlacement}
          control={<Radio disabled={fetching} />}
          label={
            <Stack
              direction="column"
              alignItems="center"
              justifyContent="center"
              gap={isMobile ? undefined : '4px'}
              sx={
                displayType === 'featured' ? selectedRadioButtonStyles : unselectedRadioButtonStyles
              }
            >
              <Image src="/static/icons/LinkOption-Featured.svg" alt="" width={67} height={39} />

              <Typography>Featured</Typography>
            </Stack>
          }
        />
      </Stack>
    )
  }, [displayType, fetching, isMobile])

  return (
    <Stack direction="column" gap={'8px'}>
      <Box>
        <Typography variant="labelLarge">Image Display Type</Typography>
      </Box>
      <Box>
        <RadioGroup
          defaultValue={displayType ?? 'noImage'}
          label=""
          hiddenLabel
          aria-labelledby="linkform-radio-buttons-group-label"
          name="radio-buttons-group"
          onChange={onChange}
        >
          {RadioOptions}
        </RadioGroup>
      </Box>
    </Stack>
  )
}
